// extracted by mini-css-extract-plugin
export default {"base":"Back-module_base_a51a1"};